var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"app-footer"},[_c('span',[_c('a',{attrs:{"href":_vm.$t('COMPANYURL')}},[_vm._v(_vm._s(_vm.$t('COMPANYNAME')))]),_vm._v(" "+_vm._s(_vm.$t('COPYRIGHTINFO')))]),_c('span',{staticClass:"ml-auto"},[_vm._v(_vm._s(_vm.$t('POWEREDBY'))+" "),_c('a',{attrs:{"href":_vm.$t('COREAPPSURL')}},[_vm._v(_vm._s(_vm.$t('COREAPSNAME')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }